// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setShareListModalIsOpen from "@insite/client-framework/Store/Components/ShareListModal/Handlers/SetShareListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    canAddWishListLineToCart,
    getWishListLinesDataView,
} from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addLinesToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import deleteWishList from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishList";
import deleteWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLines";
import exportWishList from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import loadWishLists from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishLists";
import setAllWishListLinesIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetAllWishListLinesIsSelected";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import translate from "@insite/client-framework/Translate";
import {
    CartLineCollectionModel,
    CartLineModel,
    WishListLineModel,
    WishListModel,
} from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PrintAllPagesModal from "@insite/content-library/Components/PrintAllPagesModal";
import ScheduleReminderModal, {
    ScheduleReminderModalStyles,
} from "@insite/content-library/Components/ScheduleReminderModal";
import TwoButtonModal, { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import MyListsEditListForm from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import MyListsDetailsCopyListForm from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import { markForFocusLater } from "@insite/mobius/Overlay/helpers/focusManager";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code - Start */
import OrderActionSet, {
    orderActionSetFieldDefinitions,
    OrderActionSetPresentationProps,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { formGridProps } from "@store/Themes/common/props/form";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";
import ClockFill from "@toolkit/Library/Components/Icons/Clock/ClockFill";
import CopyFill from "@toolkit/Library/Components/Icons/Copy/CopyFill";
import EditFill from "@toolkit/Library/Components/Icons/Edit/EditFill";
import Export from "@toolkit/Library/Components/Icons/Export";
import ShareFill from "@toolkit/Library/Components/Icons/Share/ShareFill";
import TrashFill from "@toolkit/Library/Components/Icons/Trash/TrashFill";
/* Valtech Custom Code - End */

/* Foundation - Start */
import StoreAddToCartRestrictionsMessage from "@store/Library/Components/Foundation/StoreAddToCartRestrictionsMessage";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import updateWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";
import loadWishListIfNeeded from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import setWishListTags from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetWishListTags";
import AddTagsModal from "@insite/content-library/Widgets/MyListsDetails/AddTagsModal";
import { IconPresentationProps } from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import PlusCircleFill from "@toolkit/Library/Components/Icons/PlusCircle/PlusCircleFill";
import StarFill from "@toolkit/Library/Components/Icons/Star/StarFill";
import StarLine from "@toolkit/Library/Components/Icons/Star/StarLine";
/* Foundation - End */

/* Valtech Custom Code - Start */
const hookPropsInjector: HookPropsInjector<Props> = (props: Props) => ({
    trackAddToCart: ga.use.trackAddToCart(undefined, {
        productInfos: getMatchingDataFromDictionary(
            props.wishListLinesDataView.value,
            props.productInfosByWishListLineId,
        ),
    }),
    trackDeleteWishList: ga.use.trackDeleteWishList({}, { wishList: props.wishList }),
    trackExportWishList: ga.use.trackExportWishList({}, { wishList: props.wishList }),
    trackAddWishListToCart: ga.use.trackAddWishListToCart(undefined, {
        productInfos: getMatchingDataFromDictionary(
            props.wishListLinesDataView.value,
            props.productInfosByWishListLineId,
        ),
    }),
});
/* Valtech Custom Code - End */

interface State {
    updateListModalIsOpen: boolean;
    deleteListModalIsOpen: boolean;
    deleteListItemsModalIsOpen: boolean;
    copyListModalIsOpen: boolean;
    printAllModalIsOpen: boolean;
    addTagsModalIsOpen: boolean;
    scheduleReminderModalIsOpen: boolean;
    closeCopyListModalOnEsc: boolean;
    // Foundation Custom Code
    confirmModalIsOpen: boolean;
    exportIsLoading: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    /* Valtech Custom Code ---> */
    const wishListLinesDataView = getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter);
    const wishListLines = wishListLinesDataView.value || [];
    const selectedWishListLineIds = state.pages.myListDetails.selectedWishListLineIds;
    const linesToAddToCart = selectedWishListLineIds.length
        ? wishListLines.filter(x => selectedWishListLineIds.includes(x.id))
        : wishListLines;
    const restrictedLines = linesToAddToCart.filter(x => !x.canAddToCart);
    /* <--- Valtech Custom Code */

    return {
        wishList: getWishListState(state, state.pages.myListDetails.wishListId).value,
        wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
        wishListSettings: getSettingsCollection(state).wishListSettings,
        selectedWishListLineIds: state.pages.myListDetails.selectedWishListLineIds,
        myListsPageLink: getPageLinkByPageType(state, "MyListsPage"),
        allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
        productInfosByWishListLineId: state.pages.myListDetails.productInfosByWishListLineId,
        isUpdatingCart: state.context.isUpdatingCart,
        isLoading: !!(
            state.pages.myListDetails.wishListId && state.data.wishLists.isLoading[state.pages.myListDetails.wishListId]
        ),
        // Valtech Custom Code
        restrictedLines,
        linesAllRestricted: restrictedLines.length === linesToAddToCart.length,
    };
};

const mapDispatchToProps = {
    addWishListToCart,
    addLinesToCart,
    deleteWishList,
    deleteWishListLines,
    loadWishLists,
    loadWishListLines: makeHandlerChainAwaitable(loadWishListLines),
    updateLoadWishListLinesParameter,
    setShareListModalIsOpen,
    setAllWishListLinesIsSelected,
    exportWishList,
    updateWishList,
    loadWishListIfNeeded,
    setWishListTags,
};

const enum fields {
    copyButton = "copyButton",
    exportButton = "exportButton",
    printButton = "printButton",
    deleteListButton = "deleteListButton",
    removeSelectedButton = "removeSelectedButton",
    addTagsButton = "addTagsButton",
    editReminderButton = "editReminderButton",
    editListButton = "editListButton",
    addListToCartButton = "addListToCartButton",
    hideButton = "hideButton",
    shareButton = "shareButton",
    // Valtech Custom Code
    addFavoritesButton = "addFavoritesButton",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.copyButton]: boolean;
        [fields.exportButton]: boolean;
        [fields.printButton]: boolean;
        [fields.deleteListButton]: boolean;
        [fields.removeSelectedButton]: boolean;
        [fields.addTagsButton]: boolean;
        [fields.editReminderButton]: boolean;
        [fields.editListButton]: boolean;
        [fields.addListToCartButton]: boolean;
        [fields.hideButton]: boolean;
        [fields.shareButton]: boolean;
        // Valtech Custom Code
        [fields.addFavoritesButton]: boolean;
    };
    trackAddToCart: ReturnType<typeof ga.use.trackAddToCart>;
    trackDeleteWishList: ReturnType<typeof ga.use.trackDeleteWishList>;
    trackExportWishList: ReturnType<typeof ga.use.trackExportWishList>;
    trackAddWishListToCart: ReturnType<typeof ga.use.trackAddWishListToCart>;
}

type Props = OwnProps & HasHistory & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>; // Valtech Custom Code

export interface MyListsDetailsActionStyles {
    wrapper?: InjectableCss;
    buttonWrapper?: InjectableCss;
    wideHidden?: HiddenProps;
    nameText?: TypographyProps;
    overflowMenu?: OverflowMenuPresentationProps;
    narrowHidden?: HiddenProps;
    printButton?: ButtonPresentationProps;
    addTagsButton?: ButtonPresentationProps;
    scheduleButton?: ButtonPresentationProps;
    editButton?: ButtonPresentationProps;
    shareButton?: ButtonPresentationProps;
    hideButton?: ButtonPresentationProps;
    addItemButton?: ButtonPresentationProps;
    removeSelectedButton?: ButtonPresentationProps;
    addListButton?: ButtonPresentationProps;
    editListModal?: ModalPresentationProps;
    deleteListModal?: TwoButtonModalStyles;
    deleteListItemsModal?: TwoButtonModalStyles;
    printListModal?: TwoButtonModalStyles;
    copyListModal?: ModalPresentationProps;
    scheduleReminderModal?: ScheduleReminderModalStyles;
    iconContainer?: InjectableCss;
    actionFavoriteClickable?: ClickablePresentationProps;
    starIcon?: IconPresentationProps;
    starXIcon?: IconPresentationProps;
    copyButton?: ButtonPresentationProps;
    exportButton?: ButtonPresentationProps;
    deleteButton?: ButtonPresentationProps;
    // Valtech Custom Code
    actionSet?: OrderActionSetPresentationProps;
    deleteLink?: LinkPresentationProps;
    scheduleLink?: LinkPresentationProps;
    editLink?: LinkPresentationProps;
    exportLink?: LinkPresentationProps;
    copyLink?: LinkPresentationProps;
    shareLink?: LinkPresentationProps;
    // Foundation
    deletedListButton?: ButtonPresentationProps;
    addTagsLink?: LinkPresentationProps;
    addFavoriteLink?: LinkPresentationProps;
    removeFavoriteLink?: LinkPresentationProps;
    hideLink?: LinkPresentationProps;
    unhideLink?: LinkPresentationProps;
}

/* Foundation - Start */
const baseTypoStyles: TypographyProps = {
    css: css`
        font-weight: ${x => x.theme.design.typography.weight.bold};
        white-space: nowrap;
    `,
};
/* Foundation - End */

export const actionStyles: MyListsDetailsActionStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            justify-content: space-between;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;

            > * {
                flex-grow: 1;

                margin: 0 1em 1em 0;

                ${breakpoint("md")} {
                    ${contentSpacingStyles(0, "1em", 0)}
                }
            }
        `,
    },
    nameText: {
        variant: "h1",
        as: "h1",
        css: css`
            margin: 0 1em 1em 0;
        `,
    },
    addItemButton: {
        typographyProps: baseTypoStyles,
        css: css`
            padding: ${pxToRem(0, 15)};
            margin-right: ${pxToRem(10)};
        `,
        variant: "secondary",
    },
    removeSelectedButton: {
        typographyProps: baseTypoStyles,
        variant: "tertiary",
    },
    addListButton: {
        typographyProps: baseTypoStyles,
    },
    deletedListButton: {
        variant: "tertiary",
    },
    editListModal: {
        sizeVariant: "small",
    },
    copyListModal: {
        sizeVariant: "small",
    },
    /* Foundation - Start */
    copyButton: {
        variant: "tertiary",
        // bunzl custom code, unsetting width is removing other styles so we're merging css now.
        mergeCss: true,
        css: css`
            width: unset;
        `,
    },
    deleteButton: {
        variant: "tertiary",
    },
    // <--- Foundation
    addTagsLink: { icon: { iconProps: { src: PlusCircleFill } } },
    addFavoriteLink: { icon: { iconProps: { src: StarLine } } },
    removeFavoriteLink: { icon: { iconProps: { src: StarFill } } },
    hideLink: { icon: { iconProps: { src: EyeOff } } },
    unhideLink: { icon: { iconProps: { src: Eye } } },
};

const styles = actionStyles;

class MyListsDetailsActions extends React.Component<Props, State> {
    static contextType = ToasterContext;
    context!: React.ContextType<typeof ToasterContext>;

    constructor(props: Props) {
        super(props);
        this.state = {
            updateListModalIsOpen: false,
            printAllModalIsOpen: false,
            addTagsModalIsOpen: false,
            deleteListModalIsOpen: false,
            deleteListItemsModalIsOpen: false,
            copyListModalIsOpen: false,
            scheduleReminderModalIsOpen: false,
            closeCopyListModalOnEsc: true,
            // Foundation
            confirmModalIsOpen: false,
            exportIsLoading: false,
        };
    }

    displayToast(message: React.ReactNode) {
        this.context.addToast({ body: message, messageType: "success" });
    }

    linesSelected() {
        return this.props.selectedWishListLineIds.length > 0;
    }

    enableAddToCart() {
        const lines = this.props.wishListLinesDataView.value;
        return (
            this.props.wishList?.canAddToCart &&
            !this.props.isUpdatingCart &&
            lines?.some(o => canAddWishListLineToCart(o, this.props.productInfosByWishListLineId)) &&
            this.allQuantitiesAreValid(lines)
        );
    }

    allQuantitiesAreValid(wishListLines: WishListLineModel[]): boolean {
        return wishListLines
            .filter(
                o =>
                    this.props.selectedWishListLineIds.length === 0 ||
                    this.props.selectedWishListLineIds.indexOf(o.id) > -1,
            )
            .every(o => o.qtyOrdered && parseFloat(o.qtyOrdered.toString()) > 0);
    }

    editClickHandler = () => {
        this.setState({ updateListModalIsOpen: true });
    };

    shareClickHandler = () => {
        this.props.setShareListModalIsOpen({ modalIsOpen: true, wishListId: this.props.wishList?.id });
    };

    printOrOpenPrintAllModal = () => {
        const { wishListLinesDataView } = this.props;
        if (!wishListLinesDataView.value || !wishListLinesDataView.pagination) {
            return null;
        }

        const {
            pagination: { totalItemCount, pageSize },
        } = wishListLinesDataView;
        if (pageSize >= totalItemCount) {
            openPrintDialog();
        } else {
            this.setState({ printAllModalIsOpen: true });
        }
    };

    closePrintModal = () => {
        this.setState({ printAllModalIsOpen: false });
    };

    editCloseHandler = () => {
        this.setState({ updateListModalIsOpen: false });
    };

    addToCartClickHandler = (e: any, hasConfirm = false /* Foundation */) => {
        e.preventDefault();
        if (!this.props.wishList || !this.props.wishListLinesDataView.value) {
            return;
        }

        /* Foundation - Start */
        if (this.props.restrictedLines.length && !hasConfirm) {
            this.setState({ confirmModalIsOpen: true });
            return;
        }
        /* Foundation - End */

        if (this.linesSelected()) {
            const selectedLines = this.props.wishListLinesDataView.value.filter(
                o => this.props.selectedWishListLineIds.indexOf(o.id) > -1,
            );
            const linesToAdd = selectedLines.filter(
                o =>
                    o.quoteRequired ||
                    o.allowZeroPricing ||
                    this.props.productInfosByWishListLineId[o.id]?.pricing?.unitNetPrice !== 0,
            );

            if (linesToAdd.length === 0) {
                this.context.addToast({ body: siteMessage("Cart_InvalidPrice"), messageType: "danger" });
                return;
            }
            const fixedLinesToAdd = linesToAdd.map(line => {
                const { categoryId, ...propertiesWithoutCategoryId } = line.properties;

                return { ...line, properties: propertiesWithoutCategoryId };
            });

            this.props.addLinesToCart({
                apiParameter: {
                    cartId: API_URL_CURRENT_FRAGMENT,
                    cartLineCollection: {
                        cartLines: fixedLinesToAdd.map(o => o as any as CartLineModel),
                    } as CartLineCollectionModel,
                },
                onSuccess: () => {
                    this.props.trackAddToCart({ items: linesToAdd }); // Valtech Custom Code
                    this.onAddToCartSuccess({
                        notAllAddedToCart: linesToAdd.length !== selectedLines.length,
                    } as CartLineCollectionModel);
                },
                onComplete(resultProps) {
                    if (resultProps.apiResult) {
                        this.onSuccess?.();
                    }
                },
            });
        } else {
            const changedSharedListLinesQuantities: Dictionary<number> = {};
            for (const wishListLineId in this.props.productInfosByWishListLineId) {
                changedSharedListLinesQuantities[wishListLineId] =
                    this.props.productInfosByWishListLineId[wishListLineId]!.qtyOrdered;
            }

            this.props.addWishListToCart({
                apiParameter: {
                    wishListId: this.props.wishList.id,
                    changedSharedListLinesQuantities,
                },
                onSuccess: (...args) => {
                    /* Valtech Custom Code */
                    this.props.trackAddWishListToCart({ items: this.props.wishListLinesDataView.value });
                    this.props.trackAddToCart({ items: this.props.wishListLinesDataView.value });
                    /* Valtech Custom Code */
                    this.onAddToCartSuccess(...args);
                },
                onComplete(resultProps) {
                    if (resultProps.apiResult) {
                        this.onSuccess?.(resultProps.apiResult);
                    }
                },
            });
        }
    };

    /* Foundation - Start */
    addToCartCancelHandler = () => {
        this.setState({ confirmModalIsOpen: false });
    };
    addToCartSubmitHandler = (e: any) => {
        this.setState({ confirmModalIsOpen: false });
        this.addToCartClickHandler(e, true);
    };
    /* Foundation - End */

    onAddToCartSuccess = (apiResult?: CartLineCollectionModel) => {
        this.displayToast(
            apiResult?.notAllAddedToCart
                ? siteMessage("Lists_Items_Not_All_Added_To_Cart")
                : siteMessage("Cart_AllProductsAddedToCart"),
        );
    };

    removeSelectedClickHandler = () => {
        this.setState({ deleteListItemsModalIsOpen: true });
    };

    removeSelectedCancelHandler = () => {
        this.setState({ deleteListItemsModalIsOpen: false });
    };

    removeSelectedSubmitHandler = () => {
        if (!this.props.wishList || !this.props.wishListLinesDataView.value) {
            return;
        }

        this.setState({ deleteListItemsModalIsOpen: false });
        const wishListLineIds = this.props.wishListLinesDataView.value
            .filter(o => this.props.selectedWishListLineIds.indexOf(o.id) > -1)
            .map(o => o.id);
        this.props.deleteWishListLines({
            wishListId: this.props.wishList.id,
            wishListLineIds,
            onSuccess: this.onRemoveSelectedSuccess,
            onComplete() {
                this.onSuccess?.();
            },
        });
    };

    onRemoveSelectedSuccess = () => {
        this.displayToast(translate(`Item${this.props.selectedWishListLineIds.length > 1 ? "s" : ""} Deleted`));
        this.props.setAllWishListLinesIsSelected({ isSelected: false });
    };

    deleteClickHandler = () => {
        this.setState({ deleteListModalIsOpen: true });
    };

    deleteCancelHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
    };

    deleteSubmitHandler = () => {
        if (!this.props.wishList) {
            return;
        }

        this.setState({ deleteListModalIsOpen: false });
        this.props.myListsPageLink && this.props.history.push(this.props.myListsPageLink.url);
        this.props.deleteWishList({
            wishListId: this.props.wishList.id,
            onSuccess: this.onDeleteSuccess,
            onComplete() {
                this.onSuccess?.();
            },
        });
    };

    onDeleteSuccess = () => {
        this.displayToast(translate("List Deleted"));
        this.props.trackDeleteWishList(); // Valtech Custom Code
    };

    copyClickHandler = () => {
        this.props.loadWishLists();
        this.setState({ copyListModalIsOpen: true });
    };

    exportClickHandler = () => {
        if (!this.props.wishList) {
            return;
        }
        this.setState({ exportIsLoading: true });
        this.props.exportWishList({
            wishListId: this.props.wishList.id,
            onComplete: () => {
                this.setState({ exportIsLoading: false });
            },
        });

        this.props.trackExportWishList(); // Valtech Custom Code
    };

    copyCancelHandler = () => {
        this.setState({ copyListModalIsOpen: false });
    };

    copySubmitHandler = () => {
        this.setState({ copyListModalIsOpen: false });
    };

    disableCloseCopyListModalOnEsc = () => {
        this.setState({ closeCopyListModalOnEsc: false });
    };

    enableCloseCopyListModalOnEsc = () => {
        this.setState({ closeCopyListModalOnEsc: true });
    };

    scheduleReminderClickHandler = () => {
        this.setState({ scheduleReminderModalIsOpen: true });
    };

    closeScheduleReminderModalHandler = () => {
        this.setState({ scheduleReminderModalIsOpen: false });
    };

    toggleFavorite = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        const that = this;
        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isFavorite: !wishList.isFavorite,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    that.props.loadWishListIfNeeded({ wishListId: resultProps.result?.wishList.id });
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    addTagsClickHandler = () => {
        this.setState({ addTagsModalIsOpen: true });
    };

    closeAddTagsModalHandler = () => {
        this.setState({ addTagsModalIsOpen: false });
        const tags = this.props.wishList?.wishListTags?.map(o => o.tag);
        if (tags) {
            this.props.setWishListTags({ wishListTags: tags });
        }
    };

    toggleHide = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        const that = this;
        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isHidden: !wishList.isHidden,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    that.props.loadWishListIfNeeded({ wishListId: resultProps.result?.wishList.id });
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    render() {
        const {
            wishList,
            wishListSettings,
            wishListLinesDataView,
            allowEditingOfWishLists,
            isLoading,
            // Valtech Custom Code
            fields: widgetFields,
        } = this.props;
        if (!wishList) {
            return null;
        }
        const showEdit = !wishList.isSharedList && !wishList.isAutogenerated;
        const showShare =
            !wishList.isSharedList &&
            wishListSettings.allowMultipleWishLists &&
            wishListSettings.allowListSharing &&
            !wishList.isAutogenerated;
        const showRemoveSelected =
            (wishList.allowEdit || !wishList.isSharedList) && this.linesSelected() && !wishList.isAutogenerated;
        const showSchedule = wishListSettings.enableWishListReminders && !wishList.isAutogenerated;
        const showAddToCart = (wishListLinesDataView.value?.length || 0) > 0;
        const showCopy = wishListSettings.allowMultipleWishLists && showAddToCart;
        const addListToCartButtonText = this.linesSelected()
            ? translate("Add Selected to Cart")
            : translate("Add List to Cart");
        const scheduleButtonText = wishList.schedule ? translate("Edit Reminder") : translate("Schedule Reminder");
        const showDelete = allowEditingOfWishLists && !wishList.isSharedList && !wishList.isAutogenerated;
        const toggleHideButtonText = wishList.isHidden ? translate("Unhide List") : translate("Hide List");
        /* Valtech Custom Code - Start */
        const showExport = wishList.wishListLinesCount > 0;
        const showAddTags = !wishList.isAutogenerated;
        const showHideList = !wishList.isAutogenerated;
        const hideLinkStyles = wishList.isHidden ? styles.unhideLink : styles.hideLink;
        const showAddToFavorites = !wishList.isAutogenerated;
        const addToFavoritesLabel = translate(
            wishList.isFavorite ? "Remove List from Favorites" : "Add List to Favorites",
        );
        const favoriteLinkStyles = wishList.isFavorite ? styles.removeFavoriteLink : styles.addFavoriteLink;
        /* Valtech Custom Code - End */

        const overflowItems = [];
        const wideHiddenOverflowMenu = [];
        const wideHiddenButtons = [];

        if (showCopy) {
            if (this.props.fields.copyButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.copyButton}
                        key="copy"
                        onClick={this.copyClickHandler}
                        data-test-selector="copyList"
                    >
                        {translate("Copy")}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable key="copy" onClick={this.copyClickHandler} data-test-selector="copyList">
                        {translate("Copy")}
                    </Clickable>,
                );
            }
        }

        if (this.props.fields.printButton === false) {
            wideHiddenButtons.push(
                <Button
                    {...styles.printButton}
                    key="print"
                    onClick={this.printOrOpenPrintAllModal}
                    data-test-selector="myListsDetails_printButton"
                >
                    {translate("Print")}
                </Button>,
            );
        } else {
            overflowItems.push(
                <Clickable
                    key="print"
                    onClick={this.printOrOpenPrintAllModal}
                    data-test-selector="myListsDetails_printButton"
                >
                    {translate("Print")}
                </Clickable>,
            );
        }

        if (!wishList.isAutogenerated) {
            if (this.props.fields.addTagsButton) {
                overflowItems.push(
                    <Clickable key="addTags" onClick={this.addTagsClickHandler} data-test-selector="addTags">
                        {translate("Add Tags")}
                    </Clickable>,
                );
            } else {
                wideHiddenButtons.push(
                    <Button
                        {...styles.addTagsButton}
                        key="addTags"
                        onClick={this.addTagsClickHandler}
                        data-test-selector="addTags"
                    >
                        {translate("Add Tags")}
                    </Button>,
                );
            }
        }

        if (showSchedule) {
            if (this.props.fields.editReminderButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.scheduleButton}
                        key="scheduleReminder"
                        onClick={this.scheduleReminderClickHandler}
                        data-test-selector="scheduleReminderList"
                    >
                        {scheduleButtonText}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable
                        key="scheduleReminder"
                        onClick={this.scheduleReminderClickHandler}
                        data-test-selector="scheduleReminderList"
                    >
                        {scheduleButtonText}
                    </Clickable>,
                );
            }
        }

        if (!wishList.isAutogenerated) {
            if (this.props.fields.hideButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.hideButton}
                        key="hide"
                        onClick={() => this.toggleHide(wishList)}
                        data-test-selector="myListsDetailsHide"
                        disabled={isLoading}
                    >
                        {toggleHideButtonText}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable
                        key="hide"
                        onClick={() => this.toggleHide(wishList)}
                        data-test-selector="myListsDetailsHide"
                        disabled={isLoading}
                    >
                        {toggleHideButtonText}
                    </Clickable>,
                );
            }
        }

        if (showEdit) {
            if (this.props.fields.editListButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.editButton}
                        key="edit"
                        onClick={this.editClickHandler}
                        data-test-selector="editList"
                    >
                        {translate("Edit")}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable key="edit" onClick={this.editClickHandler} data-test-selector="editList">
                        {translate("Edit")}
                    </Clickable>,
                );
            }
        }

        if (showShare) {
            if (this.props.fields.shareButton) {
                overflowItems.push(
                    <Clickable
                        key="share"
                        onClick={this.shareClickHandler}
                        data-test-selector="myListDetails_shareList"
                    >
                        {translate("Share")}
                    </Clickable>,
                );
            } else {
                wideHiddenButtons.push(
                    <Button
                        {...styles.shareButton}
                        key="share"
                        onClick={this.shareClickHandler}
                        data-test-selector="myListDetails_shareList"
                    >
                        {translate("Share")}
                    </Button>,
                );
            }
        }

        if (showRemoveSelected) {
            if (this.props.fields.removeSelectedButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.removeSelectedButton}
                        key="removeSelected"
                        onClick={this.removeSelectedClickHandler}
                        data-test-selector="myListDetails_removeSelected"
                    >
                        {translate("Remove Selected")}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable
                        key="removeSelected"
                        onClick={this.removeSelectedClickHandler}
                        data-test-selector="myListDetails_removeSelected"
                    >
                        {translate("Remove Selected")}
                    </Clickable>,
                );
            }
        }

        if (this.props.fields.addListToCartButton) {
            overflowItems.push(
                <Clickable
                    key="addToCart"
                    disabled={!this.enableAddToCart() || !showAddToCart}
                    onClick={this.addToCartClickHandler}
                    data-test-selector="myListDetails_addListToCart"
                >
                    {addListToCartButtonText}
                </Clickable>,
            );
        } else {
            wideHiddenButtons.push(
                <Button
                    key="addToCart"
                    disabled={!this.enableAddToCart() || !showAddToCart}
                    {...styles.addListButton}
                    onClick={this.addToCartClickHandler}
                    data-test-selector="myListDetails_addListToCart"
                >
                    {addListToCartButtonText}
                </Button>,
            );
        }

        if (wishList.wishListLinesCount > 0) {
            if (this.props.fields.exportButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.exportButton}
                        key="export"
                        onClick={this.exportClickHandler}
                        data-test-selector="exportList"
                    >
                        {translate("Export")}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable key="export" onClick={this.exportClickHandler} data-test-selector="exportList">
                        {translate("Export")}
                    </Clickable>,
                );
            }
        }

        if (showDelete) {
            if (this.props.fields.deleteListButton === false) {
                wideHiddenButtons.push(
                    <Button
                        {...styles.deleteButton}
                        key="delete"
                        onClick={this.deleteClickHandler}
                        data-test-selector="deleteList"
                    >
                        {translate("Delete")}
                    </Button>,
                );
            } else {
                overflowItems.push(
                    <Clickable key="delete" onClick={this.deleteClickHandler} data-test-selector="deleteList">
                        {translate("Delete")}
                    </Clickable>,
                );
            }
        }

        if (overflowItems.length > 0) {
            wideHiddenOverflowMenu.push(
                <OverflowMenu key="overflowMenu" onOpen={markForFocusLater} {...styles.overflowMenu}>
                    {overflowItems}
                </OverflowMenu>,
            );
        }

        return (
            <>
                {/* Valtech Custom Code - Start */}
                <OrderActionSet
                    fields={widgetFields}
                    overridedStyles={{
                        inlineOrderActions: {
                            extendedStyles: {
                                flexWrapper: {
                                    content: {
                                        css: css`
                                            justify-content: flex-end;
                                        `,
                                    },
                                },
                            },
                        },
                    }}
                    actions={[
                        {
                            key: "edit",
                            label: translate("Edit"),
                            onClick: this.editClickHandler,
                            buttonStyles: styles.editButton,
                            linkStyles: styles.editLink,
                            isVisible: showEdit,
                            field: fields.editListButton,
                        },
                        {
                            key: "share",
                            label: translate("Share"),
                            onClick: this.shareClickHandler,
                            buttonStyles: styles.shareButton,
                            linkStyles: styles.shareLink,
                            isVisible: showShare,
                            field: fields.shareButton,
                            testSelector: "myListDetails_shareList",
                        },
                        { preset: "print", field: fields.printButton },
                        {
                            key: "copy",
                            label: translate("Copy"),
                            onClick: this.copyClickHandler,
                            buttonStyles: styles.copyButton, // Foundation
                            linkStyles: styles.copyLink,
                            isVisible: showCopy,
                            field: fields.copyButton,
                            testSelector: "copyList",
                        },
                        {
                            key: "export",
                            label: translate("Export"),
                            onClick: this.exportClickHandler,
                            buttonStyles: styles.exportButton, // Foundation
                            linkStyles: styles.exportLink,
                            field: fields.exportButton,
                            isVisible: showExport,
                            testSelector: "exportList",
                            isLoading: this.state.exportIsLoading,
                        },
                        {
                            key: "delete",
                            label: translate("Delete"),
                            onClick: this.deleteClickHandler,
                            buttonStyles: styles.deleteButton, // Foundation
                            linkStyles: styles.deleteLink,
                            isVisible: showDelete,
                            field: fields.deleteListButton,
                            testSelector: "deleteList",
                        },
                        {
                            key: "schedule",
                            label: scheduleButtonText,
                            onClick: this.scheduleReminderClickHandler,
                            linkStyles: styles.scheduleLink,
                            isVisible: showSchedule,
                            field: fields.editReminderButton,
                            testSelector: "scheduleReminderList",
                        },
                        {
                            isDisabled: !this.enableAddToCart() || !showAddToCart,
                            key: "addLisToCart",
                            label: addListToCartButtonText,
                            onClick: this.addToCartClickHandler,
                            buttonStyles: styles.addListButton,
                            isVisible: showAddToCart,
                            field: fields.addListToCartButton,
                            testSelector: "myListDetails_addListToCart",
                        },
                        {
                            key: "remove",
                            label: translate("Remove Selected"),
                            onClick: this.removeSelectedClickHandler,
                            buttonStyles: styles.removeSelectedButton,
                            isVisible: showRemoveSelected,
                            field: fields.removeSelectedButton,
                            testSelector: "myListDetails_removeSelected",
                        },
                        {
                            key: "addTags",
                            label: translate("Add Tags"),
                            onClick: this.addTagsClickHandler,
                            linkStyles: styles.addTagsLink,
                            isVisible: showAddTags,
                            field: fields.addTagsButton,
                            testSelector: "addTags",
                        },
                        {
                            key: "addFavorites",
                            label: addToFavoritesLabel,
                            onClick: () => this.toggleFavorite(wishList),
                            linkStyles: favoriteLinkStyles,
                            isVisible: showAddToFavorites,
                            field: fields.addFavoritesButton,
                            testSelector: "myListsDetailsFavorite",
                        },
                        {
                            key: "hide",
                            label: toggleHideButtonText,
                            onClick: () => this.toggleHide(wishList),
                            linkStyles: hideLinkStyles,
                            isVisible: showHideList,
                            field: fields.hideButton,
                            testSelector: "myListsDetailsHide",
                        },
                    ]}
                />
                {/* Valtech Custom Code - End */}
                <Modal
                    headline={translate("Edit List Detail")}
                    {...styles.editListModal}
                    isOpen={this.state.updateListModalIsOpen}
                    handleClose={this.editCloseHandler}
                >
                    <MyListsEditListForm
                        wishList={wishList}
                        onCancel={this.editCloseHandler}
                        onSubmit={this.editCloseHandler}
                    ></MyListsEditListForm>
                </Modal>
                <TwoButtonModal
                    headlineText={translate("Delete List")}
                    {...styles.deleteListModal}
                    modalIsOpen={this.state.deleteListModalIsOpen}
                    messageText={`${translate("Are you sure you want to delete")} ${wishList.name}?`}
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Delete")}
                    onCancel={this.deleteCancelHandler}
                    onSubmit={this.deleteSubmitHandler}
                    submitTestSelector="submitDeleteList"
                ></TwoButtonModal>
                {/* Foundation - Start */}
                <TwoButtonModal
                    headlineText={translate("Add to Cart")}
                    modalIsOpen={this.state.confirmModalIsOpen}
                    messageText={
                        <StoreAddToCartRestrictionsMessage
                            list={this.props.restrictedLines.map(x => x.shortDescription)}
                            isAll={this.props.linesAllRestricted}
                        />
                    }
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Continue")}
                    onCancel={this.addToCartCancelHandler}
                    onSubmit={this.addToCartSubmitHandler}
                />
                {/* Foundation - End */}
                <TwoButtonModal
                    headlineText={translate(`Delete Item${this.props.selectedWishListLineIds.length > 1 ? "s" : ""}`)}
                    {...styles.deleteListItemsModal}
                    modalIsOpen={this.state.deleteListItemsModalIsOpen}
                    messageText={translate(
                        `Are you sure you want to delete ${
                            this.props.selectedWishListLineIds.length > 1 ? "these items" : "this item"
                        }?`,
                    )}
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Delete")}
                    onCancel={this.removeSelectedCancelHandler}
                    onSubmit={this.removeSelectedSubmitHandler}
                    submitTestSelector="submitDeleteListItems"
                ></TwoButtonModal>
                {wishListLinesDataView.value && (
                    <PrintAllPagesModal
                        isOpen={this.state.printAllModalIsOpen}
                        handleClose={this.closePrintModal}
                        updateParameterFunction={pageSize =>
                            this.props.updateLoadWishListLinesParameter({ wishListId: wishList.id, pageSize })
                        }
                        awaitableLoader={this.props.loadWishListLines}
                        initialPageSize={
                            wishListLinesDataView.value ? wishListLinesDataView.pagination?.pageSize || 8 : 8
                        }
                        reloading={false}
                        lineCollection={{
                            pagination: wishListLinesDataView.value ? wishListLinesDataView?.pagination || null : null,
                        }}
                        styles={styles.printListModal}
                    />
                )}
                <Modal
                    headline={translate("Copy List")}
                    isOpen={this.state.copyListModalIsOpen}
                    handleClose={this.copyCancelHandler}
                    closeOnEsc={this.state.closeCopyListModalOnEsc}
                    {...styles.copyListModal}
                >
                    <MyListsDetailsCopyListForm
                        onCancel={this.copyCancelHandler}
                        onSubmit={this.copySubmitHandler}
                        enableCloseCopyListModalOnEsc={this.enableCloseCopyListModalOnEsc}
                        disableCloseCopyListModalOnEsc={this.disableCloseCopyListModalOnEsc}
                    ></MyListsDetailsCopyListForm>
                </Modal>
                <ScheduleReminderModal
                    wishList={wishList}
                    isOpen={this.state.scheduleReminderModalIsOpen}
                    handleClose={this.closeScheduleReminderModalHandler}
                    extendedStyles={styles.scheduleReminderModal}
                />
                <AddTagsModal isOpen={this.state.addTagsModalIsOpen} handleClose={this.closeAddTagsModalHandler} />
            </>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withHookProps(withHistory(MyListsDetailsActions), hookPropsInjector)), // Valtech Custom Code,
    definition: {
        group: "My Lists Details",
        displayName: "Actions",
        allowedContexts: ["MyListsDetailsPage"],
        /* Valtech Custom Code - Start */
        fieldDefinitions: orderActionSetFieldDefinitions([
            { name: fields.editListButton, displayName: "Show Edit" },
            { name: fields.shareButton, displayName: "Show Share" },
            { name: fields.printButton, displayName: "Show Print" },
            { name: fields.copyButton, displayName: "Show Copy" },
            { name: fields.exportButton, displayName: "Show Export" },
            { name: fields.deleteListButton, displayName: "Show Delete" },
            { name: fields.editReminderButton, displayName: "Show Schedule" },
            { name: fields.addListToCartButton, displayName: "Show Add to Cart" },
            { name: fields.removeSelectedButton, displayName: "Show Remove Selectd" },
            { name: fields.addFavoritesButton, displayName: "Show Favorites" },
            { name: fields.addTagsButton, displayName: "Show Add Tags" },
            { name: fields.hideButton, displayName: "Show Hide" },
        ]),
        /* Valtech Custom Code - End */
    },
};

export default widgetModule;
